<template>
  <BasePopper class="text-clamped-tooltip" :offset-y="22">
    <div ref="textWrapperRef" class="text-wrapper">
      <slot />
    </div>
    <template v-if="textClamped" #content="props">
      <div class="content">
        <slot name="content" v-bind="props" />
      </div>
    </template>
  </BasePopper>
</template>

<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import { debounce } from 'lodash-es'

const isTextClamped = (el: HTMLElement, heightMargin = 5): boolean =>
  el.scrollHeight > el.clientHeight + heightMargin

const textClamped = ref(false)
const textWrapperRef = ref<HTMLDivElement | null>(null)

const determineTextClamped = debounce(() => {
  if (!textWrapperRef.value) return
  const textWrapperChild = textWrapperRef.value.children?.[0] as
    | HTMLElement
    | undefined
  if (!textWrapperChild) return

  textClamped.value = isTextClamped(textWrapperChild)
}, 200)

const textWrapperSize = useElementSize(textWrapperRef)
watch([textWrapperSize.width, textWrapperSize.height], determineTextClamped, {
  immediate: true
})
</script>

<style scoped lang="scss">
.content {
  @include flex-col;
  gap: rem(8px);

  width: 90%;
  max-width: rem(400px);
  padding: rem(20px);
  margin-inline: auto;
  background-color: $layout-background-02;
  border-radius: $border-radius-small;
  box-shadow: $base-shadow;
}
</style>
